

<template>
  <div>
    <navAndSide></navAndSide>
    <router-view></router-view>
    <footNav></footNav>
    <trial-dialog :visible.sync="trialDialogVisible" />
  </div>
</template>

<script>
import TrialDialog from './components/TrialDialog.vue'

export default {
  name: 'App',
  components: { TrialDialog },
  data () {
    return {
      trialDialogVisible: false
    }
  },
  provide () {
    return {
      openTrialDialog: this.openTrialDialog
    }
  },
  methods: {
    openTrialDialog () {
      this.trialDialogVisible = true
    }
  }
}
</script>

<style scoped>
</style>

